

const cronOptions={
	minutes: {
		istab: "minutes/",
		active: true,
		value: 3, //il valore sono i minuti di intervallo
	},
	hourly: {
		istab: "hourly/",
		active: false,
		value: 1,
		radio: "every/", // every/ o at? 
		at: {
			hour: 12,
			minute: 0,
		}
	},
	daily: {
		istab: "daily/",
		active: false,
		radio: "everyDay?", // everyDay? o weekdays?
		at: {
			hour: 12,
			minute: 0,
		}
	},
	weekly: {
		istab: "weekly?",
		active: false,
		days: [],
		at: {
			hour: 12,
			minute: 0,
		}
	},
	monthly: {
		istab: "monthly/",
		active: false,
		radio: "fixed", // fixed o recurrent
		day: 1,
		ofEvery: 1,
		ddRank: "first",
		ddDay: "mon",
		ddMonth: 1,
		at: {
			hour: 12,
			minute: 0,
		}
	},
	yearly: {
		istab: "yearly/",
		active: false,
		radio: "fixed",
		day: 1,
		ofEvery: 1,
		ddRank: "first",
		ddDay: "mon",
		ddMonth: 1,
		// es: /first/tue/ofEvery/3
		at: {
			hour: 12,
			minute: 0,
		}
	},
};

const weekDays = {
  Monday: "mon",
  Tuesday: "tue",
  Wednesday: "wed",
  Thursday: "thu",
  Friday: "fri",
  Saturday: "sat",
  Sunday: "sun"
};

function fromOptionsToStringRest(cronOptions) {
    //return "monthly/day/21/ofEvery/3";
    for (const property in cronOptions) {
        var string="";
        if (cronOptions[property]["active"]) {

            if (cronOptions[property]["istab"]=="minutes/") {
                string=cronOptions[property]["istab"]+cronOptions[property]["value"];
                return string;
            }
            if (cronOptions[property]["istab"]=="hourly/") {
                string=cronOptions[property]["istab"]+
                    (cronOptions[property]["radio"]=="every/"? "every/"+cronOptions[property]["value"]:"at?hour="+cronOptions[property]["at"]["hour"]+"&minute="+cronOptions[property]["at"]["minute"]);
                return string;
            }
            if (cronOptions[property]["istab"]=="daily/") {
                string=cronOptions[property]["istab"]+cronOptions[property]["radio"]+"hour="+cronOptions[property]["at"]["hour"]+"&minute="+cronOptions[property]["at"]["minute"];
                return string;
            }
            if (cronOptions[property]["istab"]=="weekly?") {
                string=cronOptions[property]["istab"]+"days="+cronOptions[property]["days"]+"&hour="+cronOptions[property]["at"]["hour"]+"&minute="+cronOptions[property]["at"]["minute"];
                return string;
            }
            if (cronOptions[property]["istab"]=="monthly/") {
                string=cronOptions[property]["istab"]+
                    (cronOptions[property]["radio"]=="fixed"? "day/"+cronOptions[property]["day"]+"/ofEvery/"+cronOptions[property]["ofEvery"]+"?hour="+cronOptions[property]["at"]["hour"]+"&minute="+cronOptions[property]["at"]["minute"]:
                        cronOptions[property]["ddRank"]+"/"+cronOptions[property]["ddDay"]+"/ofEvery/"+cronOptions[property]["ddMonth"]+"?hour="+cronOptions[property]["at"]["hour"]+"&minute="+cronOptions[property]["at"]["minute"]);
                return string;
            }
            if (cronOptions[property]["istab"]=="yearly/") {
                string=cronOptions[property]["istab"]+
                    (cronOptions[property]["radio"]=="fixed"? "atDay/"+cronOptions[property]["day"]+"/ofEvery/"+cronOptions[property]["ofEvery"]+"?hour="+cronOptions[property]["at"]["hour"]+"&minute="+cronOptions[property]["at"]["minute"]:
                        cronOptions[property]["ddRank"]+"/"+cronOptions[property]["ddDay"]+"/ofEvery/"+cronOptions[property]["ddMonth"]+"?hour="+cronOptions[property]["at"]["hour"]+"&minute="+cronOptions[property]["at"]["minute"]);
                return string;
            }
        }
    }
}

function fromStringRestToString(restString) {
    // Rimuoviamo eventuali slash iniziali
    restString=restString.startsWith('/')? restString.slice(1):restString;

    // Suddividiamo l'URL in parti prima di "?"
    const urlParts=restString.split('?');
    const path=urlParts[0]; // La parte prima del "?"
    const query=urlParts[1]? new URLSearchParams(urlParts[1]):null;

    // Suddividiamo il path in parti
    const parts=path.split('/');
    const type=parts[0]; // Il tipo (yearly, monthly, daily, hourly, etc.)
    var hour, minute;
    switch (type) {
        case 'minutes':
            const minuteInterval=parts[1]; // es: every/2
            return `0 0/${minuteInterval} * 1/1 * ? *`;

        case 'hourly':
            if (parts[1]==='at') {
                // Estraiamo i parametri della query string (hour e minute)
                hour=query.get('hour');
                minute=query.get('minute');
                return `0 ${minute} ${hour} 1/1 * ? *`;
            } else if (parts[1]==='every') {
                const hourInterval=parts[2]; // es: every/1
                return `0 0 0/${hourInterval} 1/1 * ? *`;
            }
            break;

        case 'daily':
            if (parts[1]==='everyDay') {
                hour=query.get('hour');
                minute=query.get('minute');
                return `0 ${minute} ${hour} 1/1 * ? *`;
            } else if (parts[1]==='weekdays') {
                hour=query.get('hour');
                minute=query.get('minute');
                return `0 ${minute} ${hour} ? * MON-FRI *`; // Settimana lavorativa
            }
            break;

        case 'weekly':
            hour=query.get('hour');
            minute=query.get('minute');
            const days=query.get('days');
            return `0 ${minute} ${hour} ? * ${days.toUpperCase()} *`;

        case 'monthly':
            hour=query.get('hour');
            minute=query.get('minute');
            if (parts[1]==='day') {
                const day=parts[2];
                const frequency=parts[4];
                return `0 ${minute} ${hour} ${day} 1/${frequency} ? *`;
            } else if (['first', 'second', 'third', 'fourth'].includes(parts[1])) {
                const weekPosition={ 'first': 1, 'second': 2, 'third': 3, 'fourth': 4 }[parts[1]];
                const dayOfWeek=parts[2];
                const frequency=parts[4];
                const hour=query.get('hour');
                const minute=query.get('minute');
                return `0 ${minute} ${hour} ? 1/${frequency} ${dayOfWeek.toUpperCase()}#${weekPosition} *`;
            }
            break;

        case 'yearly':
            if (parts[1]==='atDay') {
                // Gestiamo il caso specifico /yearly/atDay/X/ofEvery/Y
                const dayOfMonth=parts[2];
                const frequency=parts[4];
                hour=query.get('hour');
                minute=query.get('minute');
                return `0 ${minute} ${hour} ${dayOfMonth} ${frequency} ? *`;
            } else if (['first', 'second', 'third', 'fourth'].includes(parts[1])) {
                const weekPosition={ 'first': 1, 'second': 2, 'third': 3, 'fourth': 4 }[parts[1]];
                const dayOfWeek=parts[2];
                const month=parts[4];
                hour=query.get('hour');
                minute=query.get('minute');
                return `0 ${minute} ${hour} ? ${month} ${dayOfWeek.toUpperCase()}#${weekPosition} *`;
            }
            break;

        default:
            throw new Error('Tipo di cron non supportato.');
    }
}

// helper: mapping e utilità
const DOW_MAP = {
  SUN: 'sun', MON: 'mon', TUE: 'tue', WED: 'wed', THU: 'thu', FRI: 'fri', SAT: 'sat'
};
const REV_DOW_MAP = Object.fromEntries(Object.entries(DOW_MAP).map(([k, v]) => [v, k]));

const RANK_MAP = { 1: 'first', 2: 'second', 3: 'third', 4: 'fourth' };
const REV_RANK_MAP = Object.fromEntries(Object.entries(RANK_MAP).map(([k, v]) => [v, Number(k)]));

function cloneDefaults() {
  return {
    minutes:  { istab: 'minutes/',  active: false, value: 3 },
    hourly:   { istab: 'hourly/',   active: false, value: 1, radio: 'every/', at: { hour: 12, minute: 0 } },
    daily:    { istab: 'daily/',    active: false, radio: 'everyDay', at: { hour: 12, minute: 0 } },
    weekly:   { istab: 'weekly?',   active: false, days: [], at: { hour: 12, minute: 0 } },
    monthly:  { istab: 'monthly/',  active: false, radio: 'fixed', day: 1, ofEvery: 1, ddRank: 'first', ddDay: 'mon', ddMonth: 1, at: { hour: 12, minute: 0 } },
    yearly:   { istab: 'yearly/',   active: false, radio: 'fixed', day: 1, ofEvery: 1, ddRank: 'first', ddDay: 'mon', ddMonth: 1, at: { hour: 12, minute: 0 } },
  };
}

/**
 * Converte una cron (Quartz 7 campi) nel tuo oggetto cronOptions.
 * @param {string} cron - es. "0 0/5 * 1/1 * ? *"
 * @param {object} [opts] - { preferHourlyAt?: boolean } per disambiguare daily vs hourly-at
 * @returns {object} cronOptions popolato
 */
function fromStringToOptions(cron, opts = {}) {
  if (!cron || typeof cron !== 'string') throw new Error('Cron string non valida');
  const preferHourlyAt = !!opts.preferHourlyAt;

  // normalizza spazi multipli
  const parts = cron.trim().split(/\s+/);
  if (parts.length !== 7) throw new Error('Attesa cron Quartz a 7 campi: "sec min hour dom mon dow year"');

  const [sec, min, hour, dom, mon, dow, year] = parts;

  const options = cloneDefaults();

  // ---- Minutes: "0 0/NN * 1/1 * ? *"
  const minEvery = min.match(/^0\/(\d+)$/);
  if (sec === '0' && minEvery && hour === '*' && dom === '1/1' && mon === '*' && dow === '?' ) {
    options.minutes.active = true;
    options.minutes.value = Number(minEvery[1]);
    return options;
  }

  // ---- Hourly every: "0 0 0/NN 1/1 * ? *"
  const hourEvery = hour.match(/^0\/(\d+)$/);
  if (sec === '0' && min === '0' && hourEvery && dom === '1/1' && mon === '*' && dow === '?' ) {
    options.hourly.active = true;
    options.hourly.radio = 'every/';
    options.hourly.value = Number(hourEvery[1]);
    options.hourly.at = { hour: 0, minute: 0 };
    return options;
  }

  // ---- Daily weekdays: "0 m h ? * MON-FRI *"
  if (sec === '0' && dom === '?' && mon === '*' && dow === 'MON-FRI') {
    options.daily.active = true;
    options.daily.radio = 'weekdays';
    options.daily.at = { hour: Number(hour), minute: Number(min) };
    return options;
  }

  // ---- Weekly: "0 m h ? * MON,TUE *"  (lista DOW)
  if (sec === '0' && dom === '?' && mon === '*' && /[A-Z]{3}(,[A-Z]{3})*/.test(dow)) {
    const days = dow.split(',').map(d => (DOW_MAP[d] || DOW_MAP[d.toUpperCase()] || '').toLowerCase()).filter(Boolean);
    options.weekly.active = true;
    options.weekly.days = days.distinctBy(null);
    options.weekly.at = { hour: Number(hour), minute: Number(min) };
    return options;
  }

  // ---- Monthly fixed day: "0 m h DD 1/NN ? *"
  const monEvery = mon.match(/^1\/(\d+)$/);
  if (sec === '0' && dom.match(/^\d+$/) && monEvery && dow === '?') {
    options.monthly.active = true;
    options.monthly.radio = 'fixed';
    options.monthly.day = Number(dom);
    options.monthly.ofEvery = Number(monEvery[1]);
    options.monthly.at = { hour: Number(hour), minute: Number(min) };
    return options;
  }

  // ---- Monthly recurrent Nth weekday: "0 m h ? 1/NN DDD#K *"
  const mNth = dow.match(/^([A-Z]{3})#([1-4])$/);
  if (sec === '0' && dom === '?' && monEvery && mNth) {
    const [, DDD, K] = mNth;
    options.monthly.active = true;
    options.monthly.radio = 'recurrent';
    options.monthly.ddDay = (DOW_MAP[DDD] || DOW_MAP[DDD.toUpperCase()] || 'mon');
    options.monthly.ddRank = RANK_MAP[Number(K)] || 'first';
    options.monthly.ddMonth = Number(monEvery[1]); // nel tuo schema: "ofEvery" mesi
    options.monthly.at = { hour: Number(hour), minute: Number(min) };
    return options;
  }

  // ---- Yearly fixed day: "0 m h DD MM ? *"   (mese specifico)
  if (sec === '0' && dom.match(/^\d+$/) && mon.match(/^\d+$/) && dow === '?') {
    options.yearly.active = true;
    options.yearly.radio = 'fixed';
    options.yearly.day = Number(dom);
    options.yearly.ofEvery = Number(mon); // nel tuo schema "ofEvery" = mese (1..12)
    options.yearly.at = { hour: Number(hour), minute: Number(min) };
    return options;
  }

  // ---- Yearly Nth weekday: "0 m h ? MM DDD#K *"
  const yNth = dow.match(/^([A-Z]{3})#([1-4])$/);
  if (sec === '0' && dom === '?' && mon.match(/^\d+$/) && yNth) {
    const [, DDD, K] = yNth;
    options.yearly.active = true;
    options.yearly.radio = 'recurrent';
    options.yearly.ddDay = (DOW_MAP[DDD] || DOW_MAP[DDD.toUpperCase()] || 'mon');
    options.yearly.ddRank = RANK_MAP[Number(K)] || 'first';
    options.yearly.ddMonth = Number(mon);
    options.yearly.at = { hour: Number(hour), minute: Number(min) };
    return options;
  }

  // ---- Daily everyDay vs Hourly at (AMBIGUO): "0 m h 1/1 * ? *"
  if (sec === '0' && dom === '1/1' && mon === '*' && dow === '?'
      && !minEvery && !hourEvery) {
    const h = Number(hour), m = Number(min);
    if (preferHourlyAt) {
      // hourly "at" (singola esecuzione ogni giorno a h:m)
      options.hourly.active = true;
      options.hourly.radio = 'at';
      options.hourly.at = { hour: h, minute: m };
    } else {
      // daily everyDay (default)
      options.daily.active = true;
      options.daily.radio = 'everyDay';
      options.daily.at = { hour: h, minute: m };
    }
    return options;
  }

  // Se non combacia nulla, restituisco defaults (tutti inactive)
  return options;
}



export const CronHelper={
	"cronOptions": cronOptions,
	"weekDays" :weekDays,
	"fromStringToOptions" : fromStringToOptions,
	"fromOptionsToStringRest" :fromOptionsToStringRest,
	"fromStringRestToString" : fromStringRestToString
}